<template>
  <div v-if="!isMobile" class="c-navbar__wrapper" id="menu-header">
    <div class="p-navbar">
      <div class="nav_content jtf_between">
        <div class="nav_left">
          <div class="nav_left-item" v-for="(nav, i) of navs" :key="i">
            {{ nav }}
          </div>
        </div>
        <!-- <div class="nav_right">
          <div class="nav_right-item">検索ヒット件数</div>
        </div> -->
      </div>
    </div>
    <div class="nav_breadcrumb">
      <div class="nav_left-item" v-for="(nav, i) of navsubs" :key="i">
        {{ nav }}
        <img
          width="5"
          height="8.5"
          src="@/assets/images/arrow-right.svg"
          alt="icon"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const props = defineProps({
  navs: {
    type: Array,
    default: () => ['マイメニュー', 'メッセージ', 'オプション'],
  },
  navsubs: {
    type: Array,
    default: () => ['Home', 'メッセージ'],
  },
});
const isMobile = computed(() => store.state.common.isMobile);
</script>
